
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remedy",
      function () {
        return require("private-next-pages/remedy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remedy"])
      });
    }
  